const React = require("react");
const T = React.PropTypes;

require("./Survey.less");

const auditLoadDispatchers = require("~/events/auditLoad/auditLoadDispatchers.js");
const SurveyType = require("~/types/Survey.js").PropType;

const MajorMessage = require("../MajorMessage/MajorMessage.jsx");
const MajorLoading = require("../MajorLoading/MajorLoading.jsx");
const SurveyLoadError = require("../SurveyLoadError/SurveyLoadError.jsx");
const Page = require("../Page/Page.jsx");

const Survey = React.createClass({
    propTypes: {
        Survey: SurveyType.isRequired
    },
    componentWillMount() {
        if (this.props.Survey.Pages === null) {
            auditLoadDispatchers.LoadAudit(
                this.props.Survey.Type,
                this.props.Survey.FacilityNumber,
                this.props.Survey.GUID);
        }
    },
    componentWillReceiveProps(newProps) {
        if (!newProps.Survey.LoadError
            && !newProps.Survey.IsLoading) {
            if (this.props.Survey.GUID !== newProps.Survey.GUID) {
                auditLoadDispatchers.LoadAudit(
                    newProps.Survey.Type,
                    newProps.Survey.FacilityNumber,
                    newProps.Survey.GUID);
            }
        }        
    },
    render() {
        let message = this.GetMessage();

        if (message) {
            return (<MajorMessage>
                {message}
            </MajorMessage>);
        }

        const surveyIDPath = [
            this.props.Survey.Type,
            this.props.Survey.FacilityNumber,
            this.props.Survey.GUID];

        const page = this.props.Survey.Pages[0];

        return (<Page key={page.GUID}
                      Page={page}
                      SurveyIDPath={surveyIDPath}
                      CurrentSectionGUID={this.props.Survey.CurrentSectionGUID}
                      IsReadOnly={this.props.Survey.IsReadOnly}
                      QuestionSnapshot={this.props.Survey.CurrentQuestionSnapshot} />);
    },
    GetMessage() {
        if (this.props.Survey.LoadError) {
            return (<SurveyLoadError Error={this.props.Survey.LoadError } />);
        }

        if (this.props.Survey.IsLoading) {
            return (<MajorLoading />);
        }

        if (!(this.props.Survey.Pages || []).length) {
            return (<div className="cs-Survey__no-pages">
                <h2>
                    This survey doesn't have any pages
                    <br />
                    for some strange reason.
                </h2>
                <h3>
                    Please contact Support Services.
                </h3>
            </div>);
        }

        return null;
    }
});

module.exports = Survey;


// WEBPACK FOOTER //
// ./src/components/Survey/Survey.jsx